var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(!_vm.loggedIn)?[_c('first-load-screen')]:[_c('snack-bar'),_c('nav-drawer-left'),_c('top-bar'),_c('v-main',{staticClass:"mx-4"},[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }